import React from 'react';

const BackgroundImage = ({ src, posX, posY, multiSize = 1 }) => {
  let width = 75
  let height = 75
  const baseW = width * multiSize
  const baseH = height * multiSize
  const w = `75px`
  const h = `75px`
  const bgSize = `${baseW * 4}px`
  const bgPos = `${-1 * baseW * posY}px ${-1 * baseH * posX}px`
  
  return <div style={{
    backgroundImage: `url(${src})`,
    backgroundPosition: bgPos,
    backgroundSize: bgSize,
    width: w,
    height: h
  }} />
}

export default BackgroundImage

export const imagePosition = index => {
  const y = index % 4
  const x = Math.floor(index / 4)
  return { x, y }
}